<div class="dialog-header">
  <div class="header-title"><span style="font-size: 125%;">PTO</span></div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content timesheet-dialog">
  <form #timeEditForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>person</mat-icon>
        </div>
        <div class="field-block">
          <p-multiSelect [ngModelOptions]="{standalone: true}"
                         [options]="users"
                         [(ngModel)]="selectedUsers"
                         optionLabel="name"
                         defaultLabel="Users"
                         appendTo="body"
                         panelStyleClass="vacation-multiselect"
                         (onPanelShow)="disableClose()" (onPanelHide)="enableClose()">
          </p-multiSelect>
        </div>
      </div>
      <div class="form-row">
        <div class="label-block">
          From:
        </div>
        <div class="field-block calendar-block">
          <p-calendar [(ngModel)]="startDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      placeholder="Date"
                      [touchUI]="true" name="startDate" [showIcon]="true" [ngModelOptions]="{standalone: true}"
                      (onShow)="disableClose()" (onClose)="enableClose()" [readonlyInput]="false"
                      [showOnFocus]="false">
          </p-calendar>
        </div>
      </div>
      <div class="form-row">
        <div class="label-block">
          To:
        </div>
        <div class="field-block calendar-block">
          <p-calendar [(ngModel)]="endDate" view="date" [tabindex]="-1" type="date" readonly="readonly" placeholder="Date"
                      [touchUI]="true" name="startDate" [showIcon]="true" [ngModelOptions]="{standalone: true}"
                      (onShow)="disableClose()" (onClose)="enableClose()" [readonlyInput]="false"
                      [showOnFocus]="false">
          </p-calendar>
        </div>
      </div>
    </div>
    <div class="save-btn-block">
      <button mat-button class="save-btn" (click)="generatePdf()"
              [disabled]="generateLoading || !startDate || !endDate || selectedUsers.length === 0" tabindex="1" type="submit"
              [ngClass]="{'disabled-button': generateLoading || !startDate || !endDate || selectedUsers.length === 0}">
        <span *ngIf="!generateLoading">Generate</span>
        <lib-mini-progress-spinner *ngIf="generateLoading"></lib-mini-progress-spinner>
      </button>
    </div>
  </form>
</div>
